import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=26fce7b7"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=26fce7b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports